/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { AbstractObject } from '@src/app/model/abstract-object';
import { Core } from '@src/app/model/core';

export class Area extends AbstractObject {
    cores: Core[] = [];
  constructor(o: Partial<Area> = {}) {
    super(o);
  }
}
